<template>
	<nav :class="['device-nav', showMenu ? 'is-open' : '']">
		<div class="device-nav__close">
			<Button
				:id="`${uid}_button-close-menu`"
				:className="'btn btn--icon-only'"
				aria-label="Select to close the menu"
				title="Select to close the menu"
				:btnClickStop="closeHamburguerMenu"
				:iconClassName="'icon icon-close'"
				:iconBeforeLabel="true"
			>
			</Button>
		</div>
		<div class="device-nav__user" v-if="oidcUser">
			<span class="device-nav__greeting"
				>Hello, {{ this.firstName }}!</span
			>
			<div class="device-nav__logout">
				<Button
					aria-label="Select to logout of your account"
					title="Select to logout of your account"
					className="btn--icon-only"
					iconClassName="icon-logout"
					:btnClick="signOut"
					:iconBeforeLabel="true"
				/>
			</div>
		</div>
		<SiteMenu @close="closeHamburguerMenu" />
	</nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Button from '@/components/forms/button/button';
import SiteMenu from '@/site-components/site-menu/dynamic-site-menu';
import getFirstName from '@/composables/get-first-name';

export default {
	name: 'DeviceMenu',
	components: {
		Button,
		SiteMenu
	},
	model: {
		prop: 'showMenu',
		event: 'click'
	},
	props: {
		navigation: {
			type: Object,
			default: () => {}
		},
		showMenu: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters('oidcStore', ['oidcUser']),
		firstName() {
			return getFirstName(this.oidcUser);
		}
	},
	methods: {
		...mapActions('oidcStore', ['signOutOidc']),
		closeHamburguerMenu() {
			this.$emit('click', false);
		},
		signOut() {
			localStorage.removeItem('oidcUser');
			this.signOutOidc();
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Device Menu
    * Can use SCSS variables = TRUE
 */

.device-nav {
	top: 0;
	right: -100%;
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 100000000;
	background-color: rgba($site-nav-bkgd, 90%);
	//background-color: color.scale($site-nav-bkgd, $alpha: -10%); issue when the storybook was implemented
	overflow-x: hidden;
	visibility: hidden;
	padding: $padding-md;

	@include mq($from: md) {
		width: 45%;
	}
	// -------
	// NOTE FOR DEV: this should only render on smaller screens -- once the logic is implemented this style can be removed
	// -------
	@include mq($from: lg) {
		display: none;
	}
	// -- END NOTE --

	&.is-open {
		right: 0;
		visibility: visible;
		-webkit-animation: slideIn 1s forwards;
		-moz-animation: slideIn 1s forwards;
		animation: slideIn 1s forwards;

		@-webkit-keyframes slideIn {
			0% {
				transform: translateX(900px);
			}
			100% {
				transform: translateX(0);
			}
		}
		@-moz-keyframes slideIn {
			0% {
				transform: translateX(900px);
			}
			100% {
				transform: translateX(0);
			}
		}
		@keyframes slideIn {
			0% {
				transform: translateX(900px);
			}
			100% {
				transform: translateX(0);
			}
		}
	}
}

.device-nav__user {
	@include text-contrast($site-nav-bkgd, $white, $black);
	min-width: 320px;
	margin: $gutter-xl * 2 0 $gutter-xl;
	display: inline-flex;
	align-items: center;
}

.device-nav__greeting {
	font-size: $default-font-size - 2;
}

.device-nav__close {
	right: $padding-md;
	position: absolute;
	@include text-contrast($site-nav-bkgd, $white, $black);
	font-size: 24px;
	z-index: 1000;
}
</style>
